import { projectsTablePrefix } from "@/queries/projects-table";
import { scopedKey } from "@/queries/scope";
import { observedRead, type THintTargets } from "./types";

/** `[slug, uid, 'projects', 'bank']`: both `archived` lists. */
const banks = observedRead((scope) => scopedKey(scope, "projects", "bank"), { flag: null });

/** The Projects table's pages, every filter (NG-2804). */
const tablePages = observedRead(projectsTablePrefix, { flag: null });

/**
 * The projects domain's hint rows (NG-2794, NG-2804). One hint, two reads: a
 * project added, edited or removed elsewhere changes both the workspace's
 * project list and the Projects table. `flag: null` because both read only
 * through Query.
 */
export const PROJECTS_HINTS: THintTargets = {
  // R2, both `archived` lists: another user's create, rename, archive or
  // delete marks them, and an open picker, filter or label observing one
  // through `useProjectBank` is re-read.
  //
  // A walk already in flight is restarted as well. It may have read the list
  // before the change, and its success would clear the mark, so the change
  // would never show. A burst sends a trailing hint about a second after the
  // first, while a walk is likely out.
  //
  // The table: every filter's pages marked stale, and the one on screen re-read.
  "projects:bank": {
    flag: null,
    mark: (root, slug, cache) => {
      banks.mark(root, slug, cache);
      tablePages.mark(root, slug, cache);
      const queryKey = scopedKey(cache.scope, "projects", "bank");
      if (cache.client.isFetching({ queryKey }) === 0) return;
      void cache.client
        .cancelQueries({ queryKey })
        .then(() => cache.client.invalidateQueries({ queryKey, refetchType: "none" }));
    },
    reread: (root, slug, cache) => {
      banks.reread(root, slug, cache);
      tablePages.reread(root, slug, cache);
    },
  },
};
